export class CertificateInfo {
    certificateUpdatedFlg: string
    certificateAddedOn: string
    certificateRefID: string
    certificateURI: string

    constructor() {
        this.certificateAddedOn = ''
        this.certificateRefID = ''
        this.certificateUpdatedFlg = ''
        this.certificateURI = ''
    }
}


// WEBPACK FOOTER //
// ./src/app/bean/certificate-info.ts